import firebase from 'firebase'
// Your web app's Firebase configuration
let firebaseConfig = {
    'apiKey': 'AIzaSyD4mX4df40rtDN0C-gMIw90_tv_ZEBXasI',
    'authDomain': 'videochat-29257.firebaseapp.com',
    'projectId': 'videochat-29257',
    'storageBucket': 'videochat-29257.appspot.com',
    'messagingSenderId': '347341107340',
    'appId': '1:347341107340:web:844fed3360431185fd4ba9'
}
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig)
export default firebaseApp.firestore()